import PropTypes from 'prop-types';
import { useContext } from 'react';
import { ClientConfigurationContext } from '../../../context/ClientConfigurationContextProvider';

export default function CbusLobTable({ data }) {
    const clientConfiguration = useContext(ClientConfigurationContext);
    const totalItem = data.find(item => item.LineOfBusiness === "Total");
    const lobData = data.filter(item => item.LineOfBusiness !== "Total");

    return (clientConfiguration &&
        <div className="table-container">
            <table id="_Table" className="table">
                <thead>
                    <tr key="headers">
                        <th data-sort-method="none">LOB</th>
                        <th className="sort-header">Total Written Premium</th>
                        <th className="sort-header">Earned Premium</th>
                        <th className="sort-header">PIF</th>
                        <th className="sort-header">184 Day Retention</th>
                        {clientConfiguration.showLossRatioInReports && <th className="sort-header">Loss Ratio</th>}
                    </tr>
                </thead>
                <tbody>
                    {lobData.map((item, index) => (
                        <tr key={index}>
                            <td>{item.LineOfBusiness}</td>
                            <td>${item.WrittenPremium.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td>${item.EarnedPremium.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td>{item.Pif.toLocaleString()}</td>
                            <td>{item.RetentionHalfYear ? `${(item.RetentionHalfYear * 100).toFixed(2)}%` : "N/A"}</td>
                            {clientConfiguration.showLossRatioInReports && <td>{item.LossRatio ? `${(item.LossRatio * 100).toFixed(2)}%` : "N/A"}</td>}
                        </tr>
                    ))}
                </tbody>
                {totalItem && (
                    <tfoot>
                        <tr>
                            <td>{totalItem.LineOfBusiness}</td>
                            <td>${totalItem.WrittenPremium.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td>${totalItem.EarnedPremium.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td>{totalItem.Pif.toLocaleString()}</td>
                            <td>{totalItem.RetentionHalfYear ? `${(totalItem.RetentionHalfYear * 100).toFixed(2)}%` : "N/A"}</td>
                            {clientConfiguration.showLossRatioInReports && <td>{totalItem.LossRatio ? `${(totalItem.LossRatio * 100).toFixed(2)}%` : "N/A"}</td>}
                        </tr>
                    </tfoot>
                )}
            </table>
        </div>
    );
}

CbusLobTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            LineOfBusiness: PropTypes.string,
            WrittenPremium: PropTypes.number,
            EarnedPremium: PropTypes.number,
            Pif: PropTypes.number,
            RetentionHalfYear: PropTypes.number,
            LossRatio: PropTypes.number,
        })
    ).isRequired,
};